import * as signalR from "@microsoft/signalr";
import { UserAppContextController } from '@/controllers/context/user.appContext.controller'


export default function UserSignalrDispatcher(connection: signalR.HubConnection, controller:UserAppContextController) 
{
    connection.on("account", (dto) => controller.userSetup(dto));
}